import {
  formatDate as formatSharedDate,
  formatFileSize as formatSharedFileSize,
} from '@omokage/shared';

/**
 * Utility functions for formatting data for display
 */

/**
 * Format file size in bytes to human-readable format
 * @param bytes - File size in bytes
 * @returns Formatted string (e.g., "2.5 MB")
 */
export function formatFileSize(bytes: number): string {
  return formatSharedFileSize(bytes);
}

/**
 * Format timestamp to Japanese date/time format
 * @param timestamp - ISO string or Unix timestamp in seconds
 * @returns Formatted date string (e.g., "2024/01/15 14:30:45")
 */
export function formatDate(timestamp: string | number): string {
  return formatSharedDate(timestamp, {
    locale: 'ja-JP',
    invalidValue: '不明',
    formatOptions: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    },
  });
}
